import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home-echarts-header",
  style: {"padding":"10px 24px 0 24px","height":"auto"}
}
const _hoisted_2 = { class: "home-echarts-header__title" }

import type { PropType, Ref } from 'vue'
import { onMounted, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'


const __default__ = {
  name: 'RegionRevenueManagementGauge'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    default: ''
  },
  value: {
    type: Object as PropType<Object>
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '171px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '0px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  setup(__props) {

const props = __props
watch(() => props.value, (val) => {
  getData()
})
onMounted(() => {
  getData()
})
const spinning = ref(false)
const showECharts = ref(false)
const getData = () => {
  spinning.value = false
  showECharts.value = true
  initChart()
  // spinning.value = false
  // getNewActivatedCustomerMonthlyRevenue(queryForm).then((res) => {
  //   const salesAmountList = res.data?.salesAmountList as unknown as ItemCommonType[]
  //   const activatedCustomerMonthlyRevenueList = transChartData(salesAmountList)
  //   if (activatedCustomerMonthlyRevenueList.length) {
  //     showECharts.value = true
  //     initChart(activatedCustomerMonthlyRevenueList)
  //   } else {
  //     showECharts.value = false
  //     initChart([])
  //   }
  // }).finally(() => {
  //   spinning.value = false
  // })
}

const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, true)
const initChart = () => {
  setOptions({
    // 悬浮窗
    tooltip: {
      backgroundColor: '#1D4CD2',
      textStyle: {
        color: 'White'
      },
      formatter: function (params) {
        const toolsTipsResult = []
        /// 这里需要用括号包裹，否则会先走0 + ‘</strong>’
        toolsTipsResult.push('目标值  <strong>' + (props?.value?.targetValue ?? 0) + '</strong>')
        toolsTipsResult.push('完成值  <strong>' + (props?.value?.completeValue ?? 0) + '</strong>')
        toolsTipsResult.push('完成率  <strong>' + ((props?.value?.rateValue ?? 0) + '%') + '</strong>')
        return toolsTipsResult.join('<br>')
      }
    },
    series: [
      // 灰色背景层
      {
        type: 'gauge',
        startAngle: 180,
        endAngle: 0,
        radius: '100%',
        center: ['50%', '75%'],
        progress: {
          show: true,
          width: 14,
          roundCap: true,
          itemStyle: {
            color: '#eee'
          }
        },
        axisLine: {
          lineStyle: {
            width: 14,
            color: [[1, '#eee']]
          }
        },
        pointer: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        detail: {
          show: false
        },
        data: [
          {
            value: 100
          }
        ],
        z: 1 // 背景层在下面
      },

      // 橙色进度层
      {
        type: 'gauge',
        startAngle: 180,
        endAngle: 0,
        radius: '100%',
        center: ['50%', '75%'],
        progress: {
          show: true,
          width: 14,
          roundCap: true,
          itemStyle: {
            color: '#f90'
          }
        },
        axisLine: {
          lineStyle: {
            width: 14,
            color: [[(props?.value?.rateValue ?? 0) / 100, '#f90'], [1, 'transparent']]
          }
        },
        pointer: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        detail: {
          valueAnimation: true,
          fontSize: 18,
          fontWeight: 'bold',
          formatter: '{value} %',
          offsetCenter: [0, '-30%'],
          color: '#333'
        },
        data: [
          {
            value: props?.value?.rateValue ?? 0
          }
        ],
        z: 2 // 进度层在上面
      }
    ]
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height, marginBottom: __props.marginBottom })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1)
    ]),
    _createVNode(_component_a_spin, {
      spinning: spinning.value,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ])
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})